import Image from "next/image";
import styles from "../upsc-prestorming-prelims-test-series/prestorming.module.css";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import phone from "../../assets/images/upsc/phone.png";
import Link from "next/link";
const Prelims = () => {

   const feestructure3 =[

        {center: "Online",mode: "Batch 2 - ( Online)", start: "10th Oct 2026",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/AnnaNagar/Prestorming-B2-AnnaNagar-2026-27.pdf" target="_blank" className={`${styles.paybill}`}> 
                <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=PRESTORMING" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            }

    ]

    const Adlist =[
        {cont:"current affairs of the past two years,"},
        {cont:"complete syllabus coverage,"},
        {cont:"UPSC Simulator tests,"},
        {cont:"All-India ranking,"},
        {cont:"auto-activated retake feature, and"},
        {cont:"‘Learn more in less time’ characteristics."}
      ]
    
      const Adlist1 =[
        {cont:"Increase the candidate knowledge level."},
        {cont:"Help in recognizing the opportunity-filled areas."},
        {cont:"It helps to boost your prelims score."},
        {cont:"Preparing or revising the tiers is easy as there are sufficient gaps offered in between every level."},
        {cont:"Assist in developing a fundamental understanding of every subject."},
        {cont:"The candidate goes familiar with the Aptitude tests pattern of the IAS prelims 2025."}
      ]
    
      const Adlist2 =[
        {cont:"If you have decided to self-study for the prelims test series 2025 examinations."},
        {cont:"If you need to increase the chance of getting more scores in the UPSC Prelims Test 2025."},
        {cont:"If you are looking for a relevant or affordable program that can make you clear the UPSC Prelims 2025 quickly."}
        
      ]
    
      const Adlist3 =[
        {cont:"Sub-sectional online prelims test series UPSC: Each subject will be divided into different topics to make the preparation easier. The test has 50 questions each."},
        {cont:"Sectional tests: Each test will hold 100 questions, and every subject declared in the UPSC syllabus will be covered."},
        {cont:"CSAT test: Three tests, namely reasoning, comprehension, and GMA, will be conducted, and there will be 80 questions in each test."},
        {cont:"UPSC Mock tests 2025: Prelims Mock test series follows the UPSC pattern. 100 questions in paper 1 and 80 questions in paper 2"},
        {cont:"Current affairs: This test will hold 100 questions."}
        
      ]
    
      const Adlist4 =[
        {cont:"You can log in with a registered username and password."},
        {cont:"Access the course by clicking on “My Account.”"},
        {cont:"The online prelims test series live classes will get activated within 24 hours of enrolment."},
        {cont:"The test will be activated on the dates that are scheduled for you. You can follow the test schedule for more clearance."},
        {cont:"Flexible test timings can be chosen by the candidates to write the online prelims UPSC test series."},
        {cont:"Click on the submit button to submit the UPSC online prelims test series 2025."},
        {cont:"You will be provided All India ranking and score once you submit the test."},
        {cont:"The hints for detailed model answers are also offered."},
        {cont:"You can check out the performance chart and score from your account section."}
        
      ]
 
  return (
    <>


<section  id="courseandfees">
    <div className="container pt-xl-4" >
      <div className="row">
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Center</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Batch</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Starts on</div>
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Schedule</div> 
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Admission</div>
           <hr/>
      </div>
                    
      {feestructure3.map((item,index)=>(
        <div className={`${styles.facultyborder3} row`}>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
          {item.pay}
        </div>
          <hr/>
        </div>
      ))} 
     
    </div>
   
</section>


  <div className="container py-3 ">
        <div className="row">
          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS + CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,500/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
            <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>CSAT</p>
              <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div> 

<div className="container pb-4">
      <p className={`${styles.acheiverrank1} pt-3 pb-2`}><span style={{color:"#e21111ff"}}>Note :</span> Prestorming Batch 1- 7th Sep (Only Annanagar)<sup className= {`${styles.dot1}`}>*</sup></p>
    </div>

       <div className="container pt-md-5" id="">
        <div className="row pt-3">
          {/* <div className="col">
          <p className={`${styles.sectiontitle} mb-0`}>Online UPSC Prelims Test Series 2025</p>
          <p className={`${styles.acheiverrank} pt-md-2`}>The wait for an affordable, effective, reliable, and best Online Test Series for UPSC Prelims 2025 is finally over.
           Our Online Prelims Test Series 2025 is handled by the best experts in the field. Our Online Test Series for IAS will cover essential subjects from basic NCERT 
           to advanced level and make the candidate to quickly revise them.</p>
          <p className={`${styles.sectiontitle} pt-2`}>The critical features of our Online UPSC Prelims test series 2025 include</p>
          {Adlist.map((item,index)=>(
          <ul className={`${styles.ulclass} ps-1  mb-0`} key={index}>
                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                            {item.cont}
                            </p>
                        </div>
                    </li>      
            </ul>
            ))}
            <h2 className={`${styles.aboutheading1} pt-2`}>What do you mean by the Four-Tired Assessment module?</h2>
            <p className={`${styles.acheiverrank} pt-md-2`}>The four tires of Assessment hold four different tiers: 
            fundamentals or basics, advanced, applied, and UPSC simulator. The four-tier assessment module is a 
            creative and unique way of preparing for the UPSC Prelims. It benefits you in different forms, as it</p>
            {Adlist1.map((item,index)=>(
          <ul className={`${styles.ulclass} ps-1  mb-0`} key={index}>
                      <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                          <div className="d-inline">
                              <p className={`${styles.ullispan} d-inline`}>
                              {item.cont}
                              </p>
                          </div>
                      </li>      
              </ul>
              ))}
              <p className={`${styles.sectiontitle} pt-2 mb-0`}>Who will get the most benefit of the Shankar IAS Academy UPSC Prelims Online Test Series?</p>
              {Adlist2.map((item,index)=>(
                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                          <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                              <div className="d-inline">
                                  <p className={`${styles.ullispan} d-inline`}>
                                  {item.cont}
                                  </p>
                              </div>
                          </li>      
                  </ul>
                  ))}

          <h2 className={`${styles.aboutheading1} pt-2`}>Shankar IAS Academy Online UPSC Prelims Test Series highlights:</h2>
          <p className={`${styles.acheiverrank} pt-md-2`}>Our UPSC Online Test Series test papers are designed by faculties who have good knowledge in the field. 
          We conduct IAS mock test series, sectional and mock tests, and complete revision along with the test. The details include</p>
          {Adlist3.map((item,index)=>(
                <ul className={`${styles.ulclass} ps-1 mb-0`} key={index}>
                          <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                              <div className="d-inline">
                                  <p className={`${styles.ullispan} d-inline`}>
                                  {item.cont}
                                  </p>
                              </div>
                          </li>      
                  </ul>
                  ))}

            <h2 className={`${styles.aboutheading1} pt-2`}>Procedures for Online Prelims test series:</h2>
                {Adlist4.map((item,index)=>(
                  <ul className={`${styles.ulclass} ps-1 mb-0`} key={index}>
                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                                <div className="d-inline">
                                    <p className={`${styles.ullispan} d-inline`}>
                                    {item.cont}
                                    </p>
                                </div>
                            </li>      
                    </ul>
                    ))}
              <h2 className={`${styles.aboutheading1} pt-2 mb-0`}>Can I join in Online mode for UPSC Prelims Test Series 2025?</h2>
              <p className={`${styles.acheiverrank} pt-md-2`}>Yes, you can join Shankar IAS Academy’s Online UPSC prelims test series 2025. There are unit-wise GS tests, UPSC prelims mock tests, and CSAT test series.</p>
          </div> */}
        </div>
      </div>
</>
);
};

export default Prelims;